import { useTranslation } from 'react-i18next';
import { Notification, P2 } from 'src/components';
import { themeColors } from 'src/theme';

type PropsType = {
  isSuccessOpen: boolean;
  onCloseAcceptSuccess: () => void;
};

function AcceptContractorNotification({ isSuccessOpen, onCloseAcceptSuccess }: PropsType) {
  const { t } = useTranslation();
  return (
    <Notification
      open={isSuccessOpen}
      onClose={onCloseAcceptSuccess}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ maxWidth: '453px' }}
    >
      <P2 sx={{ color: themeColors.white, textTransform: 'none' }}>{t('contractorsPage.acceptNotificationText')}</P2>
    </Notification>
  );
}

export default AcceptContractorNotification;
